var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18667 15.3291C4.23191 15.3291 0 16.0945 0 19.1536C0 22.2152 4.205 23.0069 9.18667 23.0069C14.1414 23.0069 18.3733 22.2415 18.3733 19.1824C18.3733 16.1208 14.1683 15.3291 9.18667 15.3291Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.1862 12.4129C12.5607 12.4129 15.265 9.76455 15.265 6.45985C15.265 3.15515 12.5607 0.506836 9.1862 0.506836C5.81291 0.506836 3.10742 3.15515 3.10742 6.45985C3.10742 9.76455 5.81291 12.4129 9.1862 12.4129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.7165 6.56763C17.7165 8.25052 17.2003 9.82082 16.2952 11.1252C16.2011 11.2594 16.2842 11.4402 16.4481 11.469C16.6756 11.5061 16.9092 11.5289 17.1477 11.5337C19.5205 11.5947 21.65 10.0987 22.2383 7.84567C23.1103 4.50264 20.5516 1.50098 17.2921 1.50098C16.9386 1.50098 16.5998 1.53691 16.2696 1.60279C16.2243 1.61237 16.1754 1.63393 16.1509 1.67226C16.1191 1.72137 16.1424 1.78485 16.1742 1.82678C17.1539 3.17189 17.7165 4.80927 17.7165 6.56763Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7241 15.7185C24.2899 14.8118 23.2417 14.1901 21.6467 13.8847C20.8945 13.705 18.8569 13.4499 16.9623 13.4858C16.9342 13.4894 16.9183 13.5086 16.9158 13.5206C16.9121 13.5397 16.9207 13.5685 16.9574 13.5889C17.8331 14.0129 21.2174 15.8575 20.7918 19.7479C20.7735 19.918 20.9117 20.0617 21.0841 20.0377C21.9171 19.9216 24.0599 19.47 24.7241 18.0662C25.0922 17.3236 25.0922 16.4611 24.7241 15.7185Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/userWhite.866dc038.svg";
export { ForwardRef as ReactComponent };